<ui-videos [videos]="interface.videos"></ui-videos>
<ui-books></ui-books>
